import "./port2.css";

const Desktop2 = () => {
  return (
    <div className="desktop-2l">
      <b className="advisorsl">Advisors</b>
      <div className="divv">


        <b className="our-teaml">Our Team</b>
        <b className="ikbal-bakshul">Ikbal Bakshu</b>
        <b className="senthil-vell">
          <span>{`Senthil `}</span>
          <span className="vell">Vel</span>
        </b>
        <b className="sudar-muthalakanl">Sudar Muthalakan</b>
        <b className="ca-dr-pannail">CA Dr. Pannai M Karthikeyan</b>

        <img className="picture7-1-iconl" alt="" src="/Picture7.png" />
        <img className="picture2-1-iconl" alt="" src="/Picture2.png" />
        <img className="picture1-1-iconl" alt="" src="/Picture1.png" />
        <b className="mukilan-sivasankaranl">Mukilan Sivasankaran</b>
        <b className="directorl">Director</b>
        <b className="head-creative-andl">Head, Creative and Delivery</b>
        <b className="head-human-resourcel">Head, Human Resources</b>
        <b className="head-techl">Head, Tech</b>
        <b className="expert-cloud-technologyl">{'Expert -Cloud Technology & Gen AI'}</b>
        <b className="expert-low-techl">Expert -Law, Tech, IPR and TAX</b>
        <img className="desktop-2-childl" alt="" src="/line-1@2x.png" />
        <b className="dr-m-ramasubramani-containerl">
          <span>{`DR. M. Ramasubramani `}</span>
          <span className="vell">IPS</span>
          <span>{`(R) `}</span>
        </b>
        <b className="chairman-pannai-groupl">{`Chairman, Pannai Group of Institutions `}</b>
        <img className="picture6-2-iconl" alt="" src="/Picture6.png" />
        <img className="picture3-1-iconl" alt="" src="/33211-modified.png" />
        <img className="picture6-1-iconl" alt="" src="/Picture5.png" />
        <b className="priya-thiagarajanl">
          <span>{`Priya `}</span>
          <span className="vell">Thiagarajan</span>
        </b>
        <img className="picture4-1-iconl" alt="" src="/Picture4.png" />
      </div>
    </div>
  );
};

export default Desktop2;